module.exports = __webpack_public_path__ + "static/media/img1.0f07cb14.jpg";